__turbopack_context__.v({
  "label": "ShareProfile-module-scss-module__HO91pa__label",
  "shareSlot": "ShareProfile-module-scss-module__HO91pa__shareSlot",
});
